import FilterIcon from "@mui/icons-material/FilterListRounded";
import { Button, Stack } from "@mui/material";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import { useFilterContext } from "./FilterContext";
import { toggleVisibilityAction } from "./filterState";
import { isFilterActive } from "./handlers/filterHandlers";

interface Props {
  recordCount: number;
  totalCount?: number;
  hideRecordCount?: boolean;
}

const FilterControl = ({ recordCount, totalCount, hideRecordCount }: Props) => {
  const { filterState, setFilterState } = useFilterContext();

  const handleFiltersButtonClick = () => {
    setFilterState(toggleVisibilityAction());
  };

  const activeFiltersCount = filterState.visibleFilters.filter(isFilterActive).length;
  const buttonText = filterState.showFilters ? "Hide Filter" : activeFiltersCount > 0 ? "Filters" : "Filter";

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      {filterState.visibleFilters.length + filterState.availableFilters.length > 0 && (
        <Button color="secondary" variant="outlined" startIcon={<FilterIcon />} onClick={handleFiltersButtonClick}>
          {buttonText}
          {!filterState.showFilters && activeFiltersCount > 0 && (
            <BadgeDetached badgeContent={activeFiltersCount} color="primary" sx={{ ml: 1 }} />
          )}
        </Button>
      )}
      <RecordCounter records={recordCount} totalRecords={totalCount} hide={hideRecordCount} />
    </Stack>
  );
};

export default FilterControl;
